/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgHeadsetBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.00065 6.3335C3.00065 6.3335 3.00066 1.3335 8.00064 1.3335C13.0006 1.3335 13.0007 6.3335 13.0007 6.3335M9.66732 14.3335C12.6673 13.3335 13.0177 11.3335 13.0177 11.3335M13.0007 11.3335C12.0802 11.3335 11.334 10.5873 11.334 9.66683V8.3335C11.334 7.41302 12.0802 6.66683 13.0007 6.66683C13.9211 6.66683 14.6673 7.41302 14.6673 8.3335V9.66683C14.6673 10.5873 13.9211 11.3335 13.0007 11.3335ZM9.00065 15.3335C8.44837 15.3335 8.00065 14.8858 8.00065 14.3335C8.00065 13.7812 8.44837 13.3335 9.00065 13.3335C9.55294 13.3335 10.0007 13.7812 10.0007 14.3335C10.0007 14.8858 9.55294 15.3335 9.00065 15.3335ZM3.00065 11.3335C2.08018 11.3335 1.33398 10.5873 1.33398 9.66683V8.3335C1.33398 7.41302 2.08018 6.66683 3.00065 6.66683C3.92113 6.66683 4.66732 7.41302 4.66732 8.3335V9.66683C4.66732 10.5873 3.92113 11.3335 3.00065 11.3335Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);
const SvgHeadset = wrapIcon(SvgHeadsetBase);
export default SvgHeadset;
